import { render, staticRenderFns } from "./RecordsConnected.vue?vue&type=template&id=3f059f41&"
import script from "./RecordsConnected.vue?vue&type=script&lang=js&"
export * from "./RecordsConnected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports